import { FormsModule as NgFormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DoubleDatePickerComponent } from './double-date-picker/double-date-picker.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { SearchComponent } from './search/search.component';
import { SelectComponent } from './select/select.component';
import { TagPickerComponent } from './tag-picker/tag-picker.component';
import { TimeComponent } from './time/time.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ButtonComponent } from './button/button.component';
import { DirectivesModule } from '../directives/directives.module';
import { BlockFocusOutDirective } from './tag-picker/directives/block-focus-out.directive';
import { ScrolledListComponent } from './scrolled-list/scrolled-list.component';
import { ScrolledBarComponent } from './scroll-bar/scrolled-bar.component';
import { ScrollBarModule } from './scroll-bar/scroll-bar.module';
import { FormFieldComponent } from './fields/field/form-field.component';
import { SortTagsPipe } from './tag-picker/pipes/sort-tags.pipe';
import { ToggleComponent } from './toggle/toggle.component'
import {TranslateModule} from "@ngx-translate/core";



/**
 * Forms module
 */
@NgModule({
    imports: [
        CommonModule,
        NgFormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        ScrollBarModule,
        TranslateModule
    ],
	declarations: [
		DoubleDatePickerComponent,
		DatePickerComponent,
		SearchComponent,
		TagPickerComponent,
		SelectComponent,
		TimeComponent,
		CheckboxComponent,
		ButtonComponent,
		BlockFocusOutDirective,
		ScrolledListComponent,
		FormFieldComponent,
		SortTagsPipe,
		ToggleComponent
	],
	exports: [
		DoubleDatePickerComponent,
		DatePickerComponent,
		SearchComponent,
		TagPickerComponent,
		SelectComponent,
		TimeComponent,
		CheckboxComponent,
		ButtonComponent,
		BlockFocusOutDirective,
		ScrolledListComponent,
		FormFieldComponent,
		ToggleComponent
	],
	providers: [
	],

})
export class FormsModule { }
